import { createRoot } from "react-dom/client";
import React, { ComponentType } from "react";
import { Config } from "@kaltura/mediaspace-shared-data-kms-config/Config";
import { StatusScreen } from "@kaltura/mediaspace-shared-ui";
import { TopLevelComponentWrappers, getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const Verification = React.lazy(() => import("@mediaspace/features/registration/verification/Verification"));

const Unregister = React.lazy(() => import("@mediaspace/features/registration/unregister/Unregister"));

const Registration = React.lazy(() => import("@mediaspace/features/registration/registration/SiteRegistration"));

const Confirmation = React.lazy(() => import("@mediaspace/features/registration/confirmation/Confirmation"));
const ConfirmationError = React.lazy(
    () => import("@mediaspace/features/registration/confirmation-error/ConfirmationError")
);

const RegistrationEmbedForm = React.lazy(() => import("@mediaspace/features/registration-embed-form"));

const PostRegistrationRsvp = React.lazy(
    () => import("@mediaspace/features/registration/post-registration/rsvp-list/RsvpList")
);

/**
 * this will be used to render other components/pages
 */
const render = (
    containerId: string,
    props: React.ComponentProps<any> & { context: Config; component: ComponentType<any> }
) => {
    const { context, component: Component, ...rest } = props;

    const root = createRoot(document.getElementById(containerId)!);
    root.render(
        <TopLevelComponentWrappers context={context}>
            <Component {...rest} />
        </TopLevelComponentWrappers>
    );
};

export const renderEmbedForm = getStandaloneComponentRenderer(RegistrationEmbedForm);

export {
    render,
    Verification,
    Registration,
    StatusScreen,
    Confirmation,
    ConfirmationError,
    Unregister,
    PostRegistrationRsvp,
};
